function c(t) {
  return Object.prototype.toString.call(t) === "[object Object]";
}
function s(t) {
  return t === "__proto__" || t === "constructor" || t === "prototype";
}
function i(t) {
  return typeof structuredClone == "function" ? structuredClone(t) : JSON.parse(JSON.stringify(t));
}
function u(...t) {
  const o = {};
  for (const r of t) for (const [n, e] of Object.entries(r))
    s(n) || (c(e) && c(o[n]) ? o[n] = u(o[n], e) : o[n] = e);
  return o;
}
function f(t, o) {
  const r = {};
  for (const n of o) n in t && (r[n] = t[n]);
  return r;
}
function l(t, o) {
  const r = { ...t };
  for (const n of o) delete r[n];
  return r;
}
function a(t, o) {
  return Object.prototype.hasOwnProperty.call(t, o);
}
export {
  u as a,
  s as i,
  a as n,
  l as o,
  c as r,
  f as s,
  i as t
};

//# sourceMappingURL=object-BCk-1c8T.js.map